import React from 'react';
import { useKatalFeatureFlag } from 'libs/hooks';
import MilestoneAntD from './component-antd';
import MilestoneKatal from './component-katal';

interface MilestoneProps {
  isOpen?: boolean;
  milestone: any;
  toggleOpen: any;
  inquiries?: any[];
  customContent?: React.ReactNode;
}

const Milestone = (props: MilestoneProps) => {
  const useKatal = useKatalFeatureFlag();

  return useKatal ? (
    <MilestoneKatal {...props} />
  ) : (
    <MilestoneAntD {...props} />
  );
};

export default Milestone;
